import React from 'react'
import email from '../image/email.png'

const Contact = () => {
  return (
    <div id='contact' className='flex flex-col justify-center items-center my-7'>
        <h1 className='text-3xl'>Contact</h1>
        <button className='border py-1 rounded-3xl px-2 border-blue-700 hover:bg-zinc-300 my-2 transition-all'><a href="mailto:ar101101101@gmail.com"><img src={email} alt="email-logo" className='inline w-7'/> Send E-mail</a></button>
    </div>
  )
}

export default Contact